import { FirebaseApp, initializeApp } from 'firebase/app';
import {
  Auth,
  GoogleAuthProvider,
  connectAuthEmulator,
  getAuth,
} from 'firebase/auth';
import {
  Firestore,
  getFirestore,
  connectFirestoreEmulator,
} from 'firebase/firestore';
import {
  Functions,
  getFunctions,
  connectFunctionsEmulator,
} from 'firebase/functions';
import { emulatorPorts, firebaseConfig } from '@recipe-rack/shared';

export const app: FirebaseApp = initializeApp(firebaseConfig);
export const db: Firestore = getFirestore(app);
export const functions: Functions = getFunctions(app);
export const auth: Auth = getAuth(app);
export const googleProvider: GoogleAuthProvider = new GoogleAuthProvider();

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

if (isLocalhost) {
  connectFirestoreEmulator(db, 'localhost', emulatorPorts.firestore);
  connectFunctionsEmulator(functions, 'localhost', emulatorPorts.functions);
  connectAuthEmulator(auth, `http://localhost:${emulatorPorts.auth}`);
}
